import { render, staticRenderFns } from "./new.variables.page.vue?vue&type=template&id=4dfc6aae&"
import script from "./new.variables.page.vue?vue&type=script&lang=js&"
export * from "./new.variables.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports